// eslint-disable-next-line no-unused-vars
import React from 'react';
import { styled } from '@mui/material/styles';
import { TextField } from '@mui/material';

const DarkBackgroundTextField = styled(TextField)({
  // border: 'solid 3px 0xff',
  padding: '3px',
  input: {
    color: 'var(--app-primary-font-color)',
  },
  '& .MuiInput-underline:before': {
    borderBottomColor: 'var(--app-primary-font-color)',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: 'var(--app-primary-font-color)',
  },
  '& .MuiInputAdornment-root .MuiIconButton-root': {
    color: 'var(--app-primary-font-color)',
  },
  '& .MuiInputLabel-root': {
    color: 'var(--app-primary-font-color)',
    '&.Mui-error': {
      color: 'var(--app-primary-font-color)',
    },
    '&.Mui-focused': {
      color: 'var(--app-primary-font-color)',
    },
  },
  '& .MuiFormHelperText-root': {
    color: 'var(--app-primary-font-color)',
    '&.Mui-error': {
      color: 'var(--app-primary-font-color)',
    },
  },
  '& .MuiOutlinedInput-root': {
    // - The Input-root, inside the TextField-root
    '& fieldset': {
      // - The <fieldset> inside the Input-root
      borderColor: 'var(--app-primary-font-color)', // - Set the Input border
    },
    '&:hover fieldset': {
      borderColor: 'var(--app-primary-font-color)', // - Set the Input border when parent has :hover
    },
    '&.Mui-focused fieldset': {
      // - Set the Input border when parent is focused
      borderColor: 'var(--app-primary-font-color)',
    },
    '&.Mui-error fieldset': {
      // - Set the Input border when parent is errored
      borderColor: 'var(--app-primary-font-color)',
    },
  },
});

export default DarkBackgroundTextField;
